const endpoints = {
  USER_BACK: '/v2/ccp/user/back',
  USER_LEAVE: '/v2/ccp/user/leave',
  WIDGET_GET_CONVERSATIONS: '/v2/message/userConversations',
}

export class Widget {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async fetchConversationsForUser({ userUid }, opts) {
    return this.requester.get(endpoints.WIDGET_GET_CONVERSATIONS, { userUid }, opts)
  }

  async leave(conversationUids, opts) {
    return this.requester.post(endpoints.USER_LEAVE, { conversationUids: conversationUids }, opts)
  }

  async back(conversationUids, opts) {
    return this.requester.post(endpoints.USER_BACK, { conversationUids: conversationUids }, opts)
  }
}
